import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

const StyledLink = styled(Link)<{ fontWeight?: number }>`
  display: inline-block;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${({ theme }) => theme.typography.bodyL?.fontSize};
  line-height: ${({ theme }) => theme.typography.bodyL?.lineHeight};
  color: ${({ theme }) => theme.palette.customGrey.dark};
  font-weight: 500;
  transition: all 0.2s linear;
  user-select: none;

  &:hover {
    @media (min-width: 1024px) {
      color: ${({ theme }) => theme.palette.primary.main};
      transition: all 0.25s linear;
    }
  }

  &.link_sm {
    font-size: ${({ theme }) => theme.typography.bodyM?.fontSize};
    line-height: ${({ theme }) => theme.typography.bodyM?.lineHeight};
    font-weight: 300;
  }
`;

export { StyledLink };
